import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalContentAreaFn = /* @__PURE__ */ createRecipe('modalContentArea', {}, [])

const modalContentAreaVariantMap = {}

const modalContentAreaVariantKeys = Object.keys(modalContentAreaVariantMap)

export const modalContentArea = /* @__PURE__ */ Object.assign(memo(modalContentAreaFn), {
  __recipe__: true,
  __name__: 'modalContentArea',
  raw: (props) => props,
  variantKeys: modalContentAreaVariantKeys,
  variantMap: modalContentAreaVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalContentAreaVariantKeys)
  },
})